export default __webpack_public_path__ + "static/better-productivity-99f7ecc165416c479287d42f48e25753.mp4";